import { render, staticRenderFns } from "./DashboardInsights.vue?vue&type=template&id=43c19a16&scoped=true"
import script from "./DashboardInsights.vue?vue&type=script&lang=js"
export * from "./DashboardInsights.vue?vue&type=script&lang=js"
import style0 from "./DashboardInsights.vue?vue&type=style&index=0&id=43c19a16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c19a16",
  null
  
)

export default component.exports